import { render, staticRenderFns } from "./advertising1List.vue?vue&type=template&id=f872031c&scoped=true&"
import script from "./advertising1List.vue?vue&type=script&lang=js&"
export * from "./advertising1List.vue?vue&type=script&lang=js&"
import style0 from "./advertising1List.vue?vue&type=style&index=0&id=f872031c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872031c",
  null
  
)

component.options.__file = "advertising1List.vue"
export default component.exports